import React from "react";

const ProfileInput = ({ label, value, onChange, required, disabled }) => (
  <label className="block">
    <span className="mb-2 block text-[11px] uppercase tracking-[0.3em] text-zinc-500">{label}{required ? " *" : ""}</span>
    <input
      value={value || ""}
      disabled={disabled}
      required={required}
      onChange={(e) => onChange?.(e.target.value)}
      className="w-full rounded-2xl border border-white/10 bg-black/70 px-4 py-3 text-sm text-white outline-none transition focus:border-cynos-red disabled:cursor-not-allowed disabled:text-zinc-500"
    />
  </label>
);

export default ProfileInput;
